import { render, staticRenderFns } from "./PieFusionChart.vue?vue&type=template&id=089cd52b"
import script from "./PieFusionChart.vue?vue&type=script&lang=js"
export * from "./PieFusionChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports